import React, {useEffect, useState} from "react";
import {getFooter, getRedesSociales} from "../../api/footer";

export function Footer() {
    const [footer, setFooter] = useState();
    const [redesSociales, setRedesSociales] = useState();

    useEffect(()=>{
        const consultarFooter = async () => {
            getFooter().then((res) => {
                console.log(res);
                setFooter(res.data.data);
            }).catch((err) => {
                console.error(err)
            })
        }
        consultarFooter();
    },[setFooter]);

    useEffect(()=>{
        const consultarRedesSociales = async () => {
            getRedesSociales().then((res) => {
                console.log(res);
                setRedesSociales(res.data.data);
            }).catch((err) => {
                console.error(err)
            })
        }
        consultarRedesSociales();
    },[setRedesSociales]);

    if (!footer){
        return null;
    }

    const footerData = footer.attributes || footer;

    if (!footerData) {
        return null;
    }

    const {
        backgroundColor,
        textColor,
        logo,
        links,
        oficinasCentrales,
        legales,
        centroDePrensa,
        copyright,
    } = footerData;

    return (
        <footer
            className="text-center py-4 px-5 px-md-0"
            style={{
                background: backgroundColor,
                color: textColor,
            }}>
            <div className="d-flex flex-column gap-3">
                <img
                    src={logo?.data?.attributes?.url || logo?.url || logo}
                    alt="logoFooter"
                    width={200}
                    className="m-auto"
                />
                <div className="d-flex gap-3 align-self-center my-2">
                    {!redesSociales
                        ? null
                        : (redesSociales.attributes?.redesSociales || redesSociales.redesSociales)?.map((redSocial) => {
                            return (
                                <div key={redSocial.id}>
                                    <a href={redSocial.link} target="_blank" rel="noopener noreferrer">
                                        <img
                                            src={redSocial.logoDark?.data?.attributes?.url || redSocial.logoDark?.url}
                                            width={40}
                                            alt="social"
                                        />
                                    </a>
                                </div>
                            );
                        })}
                </div>
                <div className="d-flex flex-column flex-md-row gap-5 text-align-left text-md-center align-self-md-center">
                    {links.map((link) => {
                        return (
                            <a
                                href={link.link}
                                key={link.id}
                                className="text-decoration-underline font-semibold"
                            >
                                {link.texto}
                            </a>
                        );
                    })}
                </div>
                <div className="text-align-left text-md-center my-4 my-md-0">
                    <a
                        href={oficinasCentrales.link}
                        key={oficinasCentrales.id}
                        className="text-decoration-underline font-semibold"
                    >
                        {oficinasCentrales.texto}
                    </a>
                </div>
                <div className="d-flex flex-row gap-5 align-self-start align-self-md-center">
                    {legales?.map((link) => {
                        return (
                            <a
                                href={link.link}
                                key={link.id}
                                className="text-decoration-underline font-semibold"
                            >
                                {link.texto}
                            </a>
                        );
                    })}
                </div>
                <div className="text-align-left text-md-center my-4 my-md-0">
                    <span className="font-semibold">{centroDePrensa}</span>
                </div>
                <div className="text-align-left text-md-center">
                    <span className="font-semibold text-sm">{copyright}</span>
                </div>
            </div>
        </footer>
    );
}
